import { render, staticRenderFns } from "./OrdersUpload.vue?vue&type=template&id=2ae755ff&scoped=true&"
import script from "./OrdersUpload.vue?vue&type=script&lang=ts&"
export * from "./OrdersUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae755ff",
  null
  
)

export default component.exports